import React from 'react';
import { IconContainer } from './IconContainer';

const FilterIcon = (props) => {
    return (
        <IconContainer ariaLabel="filter" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.4037 6L11 12.8944V20H13V12.8944L17.5963 6H6.4037Z" />
            </svg>
        </IconContainer>
    )
}

export { FilterIcon };